
define( 'FORCES_AND_MOTION_BASICS/../nls/vi/forces-and-motion-basics-strings',{
          "none": "Không",
          "force": "Lực",
          "values": "Trị số",
          "frictionTitle": "Ma sát",
          "redWins": "Đỏ thắng!",
          "frictionForce": "Lực ma sát",
          "pause": "Dừng",
          "friction": "Ma sát",
          "accelerationLab": "PTN gia tốc",
          "forces-and-motion-basics.name": "Lực và chuyển động: Những điều cơ bản",
          "appliedForce": "Lực tác dụng",
          "leftForce": "Lực bên trái",
          "massDisplay.pattern": "{0}kg",
          "rightForce": "Lực bên phải",
          "acceleration": "Gia tốc",
          "sound": "Âm thanh",
          "lots": "Nhiều",
          "forces": "Lực",
          "motion": "Chuyển động",
          "tugOfWar": "Kéo co",
          "go": "Kéo!",
          "newtons.n": "N",
          "sumOfForcesEqualsZero": "Tổng lực = 0",
          "blueWins": "Xanh thắng!",
          "speed": "Tốc độ",
          "sumOfForces": "Tổng lực",
          "return": "Trả lại như cũ",
          "translation.credits": "Hoàng Nguyên, Sài Gòn, Việt Nam",
          "newtons": "N",
          "masses": "Khối lượng",
          "forceReadout.pattern": "{0}N"
        } );